import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../css/Formulario.css';
import { LinearProgress, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, FormHelperText } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CampoForm from '../components/CampoForm';
import { conseguirDatoCompraAValidar, validateFormContent } from '../utils/Funcs';


const FormCompra = () => {
    const pasosMaximos = 5; // Cambia esto al número total de preguntas
    const [step, setStep] = useState(1);
    const [errorMessage, setErrorMessage] = useState(''); // Estado para el mensaje de error
    const [formData, setFormData] = useState({
        nombre: '',
        telefono: '',
        correo: '',
        ubicacion: '',
        descripcionAuto: '',
        presupuesto: ''
    });

    // Variantes para las animaciones de avance y retroceso
    const variants = {
        enter: (direction) => ({
            opacity: 0,
            y: direction === 1 ? 50 : -50,  // Aparece desde arriba (retroceso) o abajo (avance)
        }),
        center: {
            opacity: 1,
            y: 0,
        },
        exit: (direction) => ({
            opacity: 0,
            y: direction !== 1 ? -50 : 50,  // Sale hacia arriba (avance) o abajo (retroceso)
        }),
    };

    const handleNext = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        if (validateFormContent(verificaciones[step-1], conseguirDatoCompraAValidar(step, formData), setErrorMessage)) {
            setErrorMessage(''); // Limpiar mensaje de error
            setStep(step + 1);
        }
    };
    
    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            handleNext(e);
        }
        if (e.key === 'Escape') {
            handleBack(e);
        }
    };

    const handleBack = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        setErrorMessage("")
        setStep(step - 1);
    };
    
    const handlePost = (e) => {
        e.preventDefault();  // Prevenir la recarga de la página
        console.log(formData)
    };

    const PREGUNTASFORMULARIO = [
        <CampoForm
            label={"Nombre y Apellido"}
            value={formData.nombre}
            funcionalidad={(e) => {setFormData({ ...formData, nombre: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
            pasos={step}
        />,
        <CampoForm
            pasos={step}
            label={"Número de Teléfono"}
            value={formData.telefono}
            type='number'
            funcionalidad={(e) => {setFormData({ ...formData, telefono: e.target.value }); validateFormContent(2, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"Correo electrónico"}
            value={formData.correo}
            funcionalidad={(e) => {setFormData({ ...formData, correo: e.target.value }); validateFormContent(3, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <CampoForm
            pasos={step}
            label={"¿En dónde se encuentra? Localidad, Barrio, Partido."}
            value={formData.ubicacion}
            funcionalidad={(e) => {setFormData({ ...formData, ubicacion: e.target.value }); validateFormContent(1, e.target.value, setErrorMessage)}}
            errorMessage={errorMessage}
            enterKey={handleEnter}
        />,
        <>
            <p>{"¿Qué auto/posibles autos estas buscando? [Detalla: Marca, Modelo, Versión y Presupuesto. Brindá la mayor cantidad de detalles posibles de tu situación, búsqueda, necesidades y objetivo.]"}</p>
            <CampoForm
                pasos={step}
                label={"Descripción"}
                value={formData.descripcionAuto}
                funcionalidad={(e) => {setFormData({ ...formData, descripcionAuto: e.target.value }); validateFormContent(8, e.target.value, setErrorMessage)}}
                errorMessage={errorMessage}
                enterKey={handleEnter}
                maxLength={350}
                multiline={true}
            />
        </>,
        // <CampoForm
        //     pasos={step}
        //     label={"¿Cual es tu presupuesto? En dólares USD"}
        //     value={formData.presupuesto}
        //     type='number'
        //     funcionalidad={(e) => {setFormData({ ...formData, presupuesto: Number(e.target.value) }); validateFormContent(9, e.target.value, setErrorMessage)}}
        //     errorMessage={errorMessage}
        //     enterKey={handleEnter}
        // />,
    ]
    const verificaciones = [1, 2, 3, 1, 8]

    const progress = ((step - 1) / (PREGUNTASFORMULARIO.length)) * 100;

    return (
        <div className='pagina-entera'>
            <LinearProgress variant="determinate" value={progress} color='success' />
            <img src={`${process.env.PUBLIC_URL}/images/IconoDelta-cortado.png`} alt="Banner de la concesionaria" className='icono-logo'/>
            <p className='titulo_form'>Quiero Comprar</p>

            <div className="formulario-container">
                <AnimatePresence mode="wait" custom={step}>
                    <motion.form 
                        key={step}  // Necesario para que AnimatePresence funcione correctamente
                        custom={step > 1 ? 1 : -1}  // Determina la dirección de la animación
                        initial="enter"
                        animate="center"
                        exit="exit"
                        variants={variants}
                        transition={{ duration: 0.5 }}
                    >
                        <div className="question">
                            {PREGUNTASFORMULARIO[step-1]}
                        </div>

                    </motion.form>
                </AnimatePresence>
            </div>
            <div className="botones-container">
                {step > 1 && <button onClick={handleBack} className='button-back'><ArrowBackIosIcon/></button>}
                {step!==PREGUNTASFORMULARIO.length && <button onClick={handleNext} className='button-forw'><ArrowForwardIosIcon/></button>}
                {step===PREGUNTASFORMULARIO.length && <button onClick={() => window.location.href = './fin'} className='button-forw'>ENVIAR</button>}
                {/* <button onClick={(e)=> {e.preventDefault(); console.log(formData);}}>printear</button> */}
            </div>
            
        </div>
    );
};

export default FormCompra;
